import { editorConfig, getDefaultTextProps } from '~config';
import { generateObjRefId } from '~core';
import { SpellCheckTextbox } from '~core/spellcheck';

const centerTextBox = (isParagraphOnTheLeft, isPageVerticale, textBoxWidth) => {
  let paragraphIndentation;
  let Indentation = window.canvas.width / 18;

  if (isPageVerticale) {
    paragraphIndentation = (window.canvas.width - textBoxWidth) / 2;
  } else if (!isPageVerticale && isParagraphOnTheLeft) {
    paragraphIndentation = Indentation;
  } else {
    paragraphIndentation = window.canvas.width - (textBoxWidth + Indentation);
  }

  return paragraphIndentation;
};

export const editorAddCordoglio = (
  cordoglio,
  isParagraphOnTheLeft,
  isPageVerticale
) => {
  const defaultTextProps = getDefaultTextProps();
  const text = cordoglio.testo;
  const sender = cordoglio.mittente.nominativo;
  const contacts = [
    cordoglio.mittente.email,
    cordoglio.mittente.telefono,
    cordoglio.mittente.indirizzo,
  ].join('\n');
  const date = cordoglio.dataIta;
  const weight = defaultTextProps['fontWeight'];
  const fontFamily = 'Times New Roman';

  const textBoxWidth = isPageVerticale
    ? window.canvas.width / 1.3
    : window.canvas.width / 2.5;

  const left = centerTextBox(
    isParagraphOnTheLeft,
    isPageVerticale,
    textBoxWidth
  );

  const fontSize = isPageVerticale
    ? Math.floor(window.canvas.width / 20)
    : Math.floor(window.canvas.width / 45);

  const senderObject = new SpellCheckTextbox(sender, {
    left,
    textAlign: 'center',
    angle: 0,
    padding: 0,
    width: textBoxWidth,
    fontFamily,
    fontSize: fontSize * 1.2,
    fontWeight: 'bold',
    fontStyle: defaultTextProps['fontStyle'],
    fill: defaultTextProps['color'],
    opacity: defaultTextProps['opacity'],
    underline: defaultTextProps['underline'],
    linethrough: defaultTextProps['linethrough'],
    hasRotatingPoint: true,
    editingBorderColor: editorConfig.lineColorDark,
    giotto: {
      objRefId: generateObjRefId('textbox'),
    },
    erasable: false,
  });

  const textObject = new SpellCheckTextbox(text, {
    left,
    textAlign: 'center',
    angle: 0,
    padding: 0,
    width: textBoxWidth,
    fontFamily,
    fontSize,
    fontWeight: weight,
    fontStyle: 'italic',
    fill: defaultTextProps['color'],
    opacity: defaultTextProps['opacity'],
    underline: defaultTextProps['underline'],
    linethrough: defaultTextProps['linethrough'],
    hasRotatingPoint: true,
    editingBorderColor: editorConfig.lineColorDark,
    giotto: {
      objRefId: generateObjRefId('textbox'),
    },
    erasable: false,
  });

  const dateObject = new SpellCheckTextbox(date, {
    left,
    textAlign: 'right',
    angle: 0,
    padding: 0,
    width: textBoxWidth,
    fontFamily,
    fontSize: fontSize * 0.6,
    fontWeight: weight,
    fontStyle: defaultTextProps['fontStyle'],
    fill: '#b5b5b5',
    opacity: defaultTextProps['opacity'],
    underline: defaultTextProps['underline'],
    linethrough: defaultTextProps['linethrough'],
    hasRotatingPoint: true,
    editingBorderColor: editorConfig.lineColorDark,
    giotto: {
      objRefId: generateObjRefId('textbox'),
    },
    erasable: false,
  });

  const contactsObject = new SpellCheckTextbox(contacts, {
    left,
    textAlign: 'left',
    angle: 0,
    padding: 0,
    width: textBoxWidth,
    fontFamily,
    fontSize: fontSize * 0.6,
    fontWeight: weight,
    fontStyle: defaultTextProps['fontStyle'],
    fill: '#b5b5b5',
    opacity: defaultTextProps['opacity'],
    underline: defaultTextProps['underline'],
    linethrough: defaultTextProps['linethrough'],
    hasRotatingPoint: true,
    editingBorderColor: editorConfig.lineColorDark,
    giotto: {
      objRefId: generateObjRefId('textbox'),
    },
    erasable: false,
  });

  // position sender and date in correct location
  window.canvas.centerObjectV(textObject);
  window.canvas.centerObjectV(senderObject);
  window.canvas.centerObjectV(dateObject);
  window.canvas.centerObjectV(contactsObject);
  dateObject.top = dateObject.height * 3;
  contactsObject.top = window.canvas.height - contactsObject.height * 2;

  sender.length >= 32
    ? (senderObject.top = textObject.top - senderObject.height * 2)
    : (senderObject.top = textObject.top - senderObject.height * 3);

  window.canvas.add(senderObject, textObject, dateObject, contactsObject);
  window.canvas.renderAll();
};
